import { Link } from "react-router-dom";
import { Seo } from "@/components/Seo";

export default function NotFound() {
  return (
    <>
      <Seo path="/404" noindex />
      <section className="section bg-ivory" data-testid="not-found-page">
        <div className="wrap max-w-2xl">
          <p className="eyebrow mb-5">404</p>
          <h1 className="text-4xl font-bold sm:text-5xl">Page Not Found</h1>
          <p className="lede mt-6">The page you’re looking for doesn’t exist.</p>
          <Link to="/" className="btn-gold mt-8" data-testid="not-found-home-link">Go to the Overview</Link>
        </div>
      </section>
    </>
  );
}
